// Remove trailing zeros after decimal point
// including decimal point itself
export function trimTrailingDecimals(value) {
  if (typeof value !== 'string') return value; // Use regex that preserves currency symbols, percent signs, etc.

  return value.replace(/(\d+(?:\.\d*?[1-9](?=0))?)\.?0*(?:\b|\B)(?![E]?\d+)/g, '$1');
}